import { SWRConfig } from 'swr';
import YourSecurity from '../src/views/YourSecurity';
import fetchAPI from '@/components/fetchAPI';

export async function getServerSideProps(context) {
  const slug = "your-security";
  const queryKey = '/api/content-pages/?slug=' + slug;
  const content = await fetchAPI(queryKey, {}, context);

  return {
    props: {
      fallback: {
        [queryKey]: content
      }
    }
  }
}

export default function PrivacyPolicyPage({ fallback }) {
  return (
    <SWRConfig value={{ fallback }}>
      <YourSecurity />
    </SWRConfig>
  )
};
